import { isNullUndefinedOrEmpty } from 'utils';

const getContracts = (appointments, year) => {
    if (isNullUndefinedOrEmpty(appointments) || !Array.isArray(appointments)) {
        return [];
    }
    return appointments.reduce(addAppointment, []).map(contract => ({ ...contract, year }));
};

const addAppointment = (contracts, appointment) => {
    const {appointmentId, type, template, description, team, appointee } = appointment;
    appointee.appointmentId = appointmentId;
    const key = `${type}_${template}`;

    const contract = contracts.find(contract => contract.key === key);
    if (contract) {
        const { teams } = contract;
        teams[team] = Object.keys(teams).includes(team) ? [...teams[team], appointee] : [appointee];
        return contracts;
    }

    return [...contracts, { key, type, template, description, teams: { [team]: [appointee] }, team: '', appointee: '', checked: 0 }];
};

export { getContracts };
